/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-06-24 16:34:40
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-25 17:25:57
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\store-euser.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';
import { login, logout, getUserInfo, getEUserInfo } from '@/data/ApiUser';
// import storeMenu from './storeMenu';
import createUserStore from 'ai-assistant-lib/src/store/create-user-store';

const { state, getters, actions } = createUserStore({
  loginApi: login,
  userInfoApi: getUserInfo,
  logoutApi: logout,
});

export default defineStore('euser', {
  state() {
    return {
      ...state(),
      loginType: 4,
      eUserInfo: {},
      hasEName: false,
    };
  },
  getters: {
    ...getters,
    userName() {
      return this.info.userName;
    },
  },
  actions: {
    ...actions,

    afterReset() {
      this.eUserInfo = {};
      this.hasEName = false;
    },

    async afterGetUserInfo() {
      this.eUserInfo = await getEUserInfo({ phid: this.info.phid });
      this.eUserInfo.defaultConfigId = this.info.defaultConfigId;
      this.hasEName = !!this.eUserInfo.ename; // 企业名用于知识库分组
    },
  },
});
